/** px to vw, 750 is the screen width you set
 * In use (Vue)
 * <div :style="{width: px2vw(20)}"></div>
 */
export const px2vw = px =>
  `calc(100vw / ${+process.env.VUE_APP_uiWidth}  * ${px})`;
